import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLiveFeed, addNewTransaction } from "../../store/transaction/transaction.action";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import formatImageUrl from "../../extra/functions";
import defaultImage from "../../../assets/images/default.jpg";
import { useNavigate } from "react-router-dom";

dayjs.extend(relativeTime);

const LiveFeed = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { liveFeed } = useSelector((state) => state.transaction);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    dispatch(getLiveFeed(20));
    setIsInitialLoad(false);

    // Set up socket listener for real-time updates
    if (window.socket) {
      window.socket.on("new_transaction", (transaction) => {
        dispatch(addNewTransaction(transaction));
      });

      return () => {
        window.socket.off("new_transaction");
      };
    }
  }, [dispatch]);

  // Auto refresh disabled - using socket for real-time updates instead
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     dispatch(getLiveFeed(20));
  //   }, 30000);
  //   return () => clearInterval(interval);
  // }, [dispatch]);

  const getTransactionIcon = (type) => {
    switch (type) {
      case "PRODUCT_PURCHASE":
        return <i className="bi bi-bag-check-fill" style={{ color: "#3B82F6" }}></i>;
      case "GIFT_PURCHASE":
        return <i className="bi bi-gift-fill" style={{ color: "#8B5CF6" }}></i>;
      case "COIN_PURCHASE":
        return <i className="bi bi-coin" style={{ color: "#E5B94E" }}></i>;
      default:
        return <i className="bi bi-currency-exchange" style={{ color: "#6B7280" }}></i>;
    }
  };

  const getTransactionLabel = (type) => {
    switch (type) {
      case "PRODUCT_PURCHASE":
        return "purchased";
      case "GIFT_PURCHASE":
        return "sent gift";
      case "COIN_PURCHASE":
        return "bought coins";
      default:
        return "transaction";
    }
  };

  return (
    <div
      className="card"
      style={{
        borderRadius: "8px",
        border: "1px solid #e5e7eb",
        background: "#fff",
        height: "100%",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)"
      }}
    >
      <div
        className="d-flex justify-content-between align-items-center p-3"
        style={{ borderBottom: "1px solid #e5e7eb", background: "#fff", borderRadius: "8px 8px 0 0" }}
      >
        <div className="d-flex align-items-center">
          <span
            className="me-2"
            style={{
              width: "8px",
              height: "8px",
              backgroundColor: "#10B981",
              borderRadius: "50%",
              animation: "pulse 2s infinite"
            }}
          ></span>
          <h6 className="mb-0" style={{ fontWeight: "600", color: "#1F2937" }}>
            Live Transaction Feed
          </h6>
        </div>
        <button
          className="btn btn-sm"
          onClick={() => navigate("/admin/transactions")}
          style={{ color: "#E5B94E", fontSize: "13px", fontWeight: "500" }}
        >
          View All
        </button>
      </div>

      <div
        className="card-body p-0"
        style={{
          maxHeight: "450px",
          overflowY: "auto",
          backgroundColor: "#fafafa"
        }}
      >
        {liveFeed?.length > 0 ? (
          liveFeed.map((txn, index) => (
            <div
              key={txn._id || index}
              className="d-flex align-items-start p-3"
              style={{
                borderBottom: "1px solid #e5e7eb",
                backgroundColor: index % 2 === 0 ? "#fff" : "#fafafa",
                animation: index === 0 && !isInitialLoad ? "slideIn 0.3s ease" : "none"
              }}
            >
              {/* Icon/Image */}
              <div
                className="me-3 d-flex align-items-center justify-content-center"
                style={{
                  width: "45px",
                  height: "45px",
                  borderRadius: "10px",
                  overflow: "hidden",
                  flexShrink: 0,
                  border: "1px solid #e5e7eb"
                }}
              >
                {txn.itemImage ? (
                  <img
                    src={formatImageUrl(txn.itemImage)}
                    alt=""
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    onError={(e) => { e.target.onerror = null; e.target.src = defaultImage; }}
                  />
                ) : (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      backgroundColor: "#f3f4f6",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "20px"
                    }}
                  >
                    {getTransactionIcon(txn.transactionType)}
                  </div>
                )}
              </div>

              {/* Content */}
              <div className="flex-grow-1">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <p className="mb-1" style={{ color: "#1F2937", fontSize: "14px" }}>
                      <span style={{ fontWeight: "600" }}>{txn.userName || "User"}</span>
                      <span style={{ color: "#6B7280" }}> {getTransactionLabel(txn.transactionType)} </span>
                      {txn.itemName && (
                        <span style={{ fontWeight: "500", color: "#374151" }}>{txn.itemName}</span>
                      )}
                    </p>
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "600",
                          color: txn.currency === "COINS" ? "#8B5CF6" : "#10B981"
                        }}
                      >
                        {txn.currency === "COINS" ? (
                          <>{txn.amount} Coins</>
                        ) : (
                          <>GH{parseFloat(txn.amount).toFixed(2)}</>
                        )}
                      </span>
                      {txn.paymentMethod && (
                        <span style={{ fontSize: "12px", color: "#9CA3AF" }}>
                          via {txn.paymentMethod}
                        </span>
                      )}
                    </div>
                  </div>
                  <span style={{ fontSize: "11px", color: "#9CA3AF", whiteSpace: "nowrap" }}>
                    {dayjs(txn.createdAt).fromNow()}
                  </span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-5" style={{ backgroundColor: "#fff" }}>
            <i className="bi bi-inbox" style={{ fontSize: "40px", color: "#d1d5db" }}></i>
            <p className="mt-2" style={{ color: "#9CA3AF" }}>No transactions yet</p>
          </div>
        )}
      </div>

      <style jsx>{`
        @keyframes pulse {
          0% { opacity: 1; }
          50% { opacity: 0.5; }
          100% { opacity: 1; }
        }
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default LiveFeed;
